import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { SecureLinkVerificationType } from '@/types/myVaultTypes';

export const getSecureLinkVerificationApi = (id: string): Promise<ApiResponseType<SecureLinkVerificationType>> => {
  return authApiService.GET(`/my-vault/links/${id}/verification/`);
};
